import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from '../app/login/login.component';
import { DashboardComponent } from '../app/dashboard/dashboard.component';
import { RedirectComponent } from './redirect/redirect.component';
import { HeaderComponent } from './header/header.component';
import { FormComponent } from './form/form.component';
import { SortformsComponent } from './sortforms/sortforms.component';
import { RouteGuard } from './services/route.gaurd';
import { SettingsComponent } from './settings/settings.component';
import { SortTopicsComponent } from './sort-topics/sort-topics.component';
import { SubmittedFormDetailsComponent } from './submitted-form-details/submitted-form-details.component';
import { FormPreviewComponent } from './form-preview/form-preview.component';
import { CompletedFormsComponent } from "./completed-forms/completed-forms.component";
import { TrashComponent } from './trash/trash.component';
import { CreateFormComponent } from './create-form/create-form.component';
import { ActionListArchivedComponent } from './dashboard/action-list-archived/action-list-archived.component';
import { RestoreArchivedItemsComponent } from "./dashboard/restore-archived-items/restore-archived-items.component";
import { ActionlistTrashComponent } from './actionlist-trash/actionlist-trash.component';
import { ActionListOrderComponent } from './action-list-order/action-list-order.component';
import { ExportActionListComponent } from './export-action-list/export-action-list.component';
import { AccountComponent } from './account/account.component';
import { TutorialVideosComponent } from './tutorial-videos/tutorial-videos.component';
import { ProfileComponent } from './profile/profile.component';
import { HelpComponent } from './help/help.component';
import { ThemeComponent } from './theme/theme.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { FlaggedFormsComponent } from "./flagged-forms/flagged-forms.component";
import { FileCabinetComponent } from './file-cabinet/file-cabinet.component';
import { FormErrorsGuard } from './services/formerrors.guard';
import { TeamSelectionComponent } from './team-selection/team-selection.component';
import { ConfigurationComponent } from './settings/configuration/configuration.component';
import { OrganizationsComponent } from './organizations/organizations.component';
import { OrganizationFormsComponent } from './organization-forms/organization-forms.component';


const routes: Routes = [
	{ path: 'login', component: LoginComponent },
	// { path: 'signup', component: SignupComponent },
	{ path: 'form-preview', component: FormPreviewComponent },
	{ path: ':orgid/form-preview', component: FormPreviewComponent },
	{ path: 'sort-sharing/url-link/:url-id', component: FormPreviewComponent },
	{ path: 'not-found', component: PageNotFoundComponent },
	// { path: 'help-faq', component: HelpFaqComponent},
	{
		path: 'teams-selection',
		component: TeamSelectionComponent,
		data: { teamSelection: true },
		canActivate: [RouteGuard],
	},
	{
		path: ':orgid/teams-selection',
		component: TeamSelectionComponent,
		data: { teamSelection: true },
		canActivate: [RouteGuard],
	},
	{
		path: '',
		canActivate: [RouteGuard],
		component: HeaderComponent,
		children: [
			{
				path: '',
				component: RedirectComponent
			},
			{
				path: 'organizations',
				component: OrganizationsComponent,
				data: { superUser: true },
				canActivate: [RouteGuard]
			},
			{
				path: ':orgid/organizations',
				component: OrganizationsComponent,
				data: { superUser: true },
				canActivate: [RouteGuard]
			},
			{
				path: 'dashboard',
				component: DashboardComponent,
				canActivate: [RouteGuard]
			},
			{
				path: ':orgid/dashboard',
				component: DashboardComponent,
				canActivate: [RouteGuard]
			},
			{
				path: 'dashboard/:actionType',
				component: DashboardComponent,
				canActivate: [RouteGuard]
			},
			{
				path: ':orgid/dashboard/:actionType',
				component: DashboardComponent,
				canActivate: [RouteGuard]
			},
			{
				path: 'form-builder',
				component: FormComponent,
				canActivate: [RouteGuard],
				canDeactivate: [FormErrorsGuard]
			},
			{
				path: ':orgid/form-builder',
				component: FormComponent,
				canActivate: [RouteGuard]
			},
			{
				path: 'sort-forms',
				component: SortformsComponent,
				canActivate: [RouteGuard]
			},
			{
				path: ':orgid/sort-forms',
				component: SortformsComponent,
				canActivate: [RouteGuard]
			},
			{
				path: 'settings',
				component: SettingsComponent,
				canActivate: [RouteGuard]
			},
			{
				path: ':orgid/settings',
				component: SettingsComponent,
				canActivate: [RouteGuard]
			},
			{
				path: 'sort-topics',
				component: SortTopicsComponent,
				canActivate: [RouteGuard]
			},
			{
				path: ':orgid/sort-topics',
				component: SortTopicsComponent,
				canActivate: [RouteGuard]
			},
			{
				path: 'formDetails/:id',
				component: SubmittedFormDetailsComponent,
				canActivate: [RouteGuard]
			},
			{
				path: ':orgid/formDetails/:id',
				component: SubmittedFormDetailsComponent,
				canActivate: [RouteGuard]
			},
			{
				path: 'formDetails/:actionType/:id',
				component: SubmittedFormDetailsComponent,
				canActivate: [RouteGuard]
			},
			{
				path: ':orgid/formDetails/:actionType/:id',
				component: SubmittedFormDetailsComponent,
				canActivate: [RouteGuard]
			},
			{
				path: 'forms/completed',
				component: CompletedFormsComponent,
				canActivate: [RouteGuard]
			},
			{
				path: ':orgid/forms/completed',
				component: CompletedFormsComponent,
				canActivate: [RouteGuard]
			},
			{
				path: 'forms/trash',
				component: TrashComponent,
				canActivate: [RouteGuard]
			},
			{
				path: ':orgid/forms/trash',
				component: TrashComponent,
				canActivate: [RouteGuard]
			},
			{
				path: 'action-list/trash',
				component: ActionlistTrashComponent,
				canActivate: [RouteGuard]
			},
			{
				path: ':orgid/action-list/trash',
				component: ActionlistTrashComponent,
				canActivate: [RouteGuard]
			},
			{
				path: 'action-list',
				component: ActionListOrderComponent,
				canActivate: [RouteGuard]
			},
			{
				path: ':orgid/action-list',
				component: ActionListOrderComponent,
				canActivate: [RouteGuard]
			},
			{
				path: 'create-form',
				component: CreateFormComponent,
				canActivate: [RouteGuard]
			},
			{
				path: ':orgid/create-form',
				component: CreateFormComponent,
				canActivate: [RouteGuard]
			},
			{
				path: 'action-list/completed',
				component: ActionListArchivedComponent,
				canActivate: [RouteGuard]
			},
			{
				path: ':orgid/action-list/completed',
				component: ActionListArchivedComponent,
				canActivate: [RouteGuard]
			},
			// {
			// 	path: 'subscription',
			// 	component: localStorage.getItem('enable_subscription') == "true" ? ConfigurationNewComponent:ConfigurationComponent,
			// 	canActivate: [RouteGuard]
			// },
			{
				path: 'subscription',
				component: ConfigurationComponent,
				canActivate: [RouteGuard]
			},
			{
				path: 'dashboard/:id/restore',
				component: RestoreArchivedItemsComponent,
				canActivate: [RouteGuard]
			},
			{
				path: ':orgid/dashboard/:id/restore',
				component: RestoreArchivedItemsComponent,
				canActivate: [RouteGuard]
			},
			{
				path: 'export-action-list/:id',
				component: ExportActionListComponent,
				canActivate: [RouteGuard]
			},
			{
				path: ':orgid/export-action-list/:id',
				component: ExportActionListComponent,
				canActivate: [RouteGuard]
			},
			{
				path: 'account',
				component: AccountComponent,
				canActivate: [RouteGuard],
				data: {}
			},
			{
				path: ':orgid/account',
				component: AccountComponent,
				canActivate: [RouteGuard]
			},
			{
				path: 'tutorial',
				component: TutorialVideosComponent,
				canActivate: [RouteGuard]
			},
			{
				path: ':orgid/tutorial',
				component: TutorialVideosComponent,
				canActivate: [RouteGuard]
			},
			{
				path: 'profile',
				component: ProfileComponent,
				canActivate: [RouteGuard]
			},
			{
				path: ':orgid/profile',
				component: ProfileComponent,
				canActivate: [RouteGuard]
			},
			{
				path: 'help',
				component: HelpComponent,
				canActivate: [RouteGuard]
			},
			{
				path: ':orgid/help',
				component: HelpComponent,
				canActivate: [RouteGuard]
			},
			{
				path: 'theme',
				component: ThemeComponent,
				canActivate: [RouteGuard]
			},
			{
				path: ':orgid/theme',
				component: ThemeComponent,
				canActivate: [RouteGuard]
			},
			{
				path: 'forms/flagged',
				component: FlaggedFormsComponent,
				canActivate: [RouteGuard]
			},
			{
				path: 'file-cabinet',
				component: FileCabinetComponent,
				canActivate: [RouteGuard]
			},
			{
				path: 'org-forms/:id',
				component: OrganizationFormsComponent,
				canActivate: [RouteGuard]
			},
			{
				path: ':orgid/org-forms/:id',
				component: OrganizationFormsComponent,
				canActivate: [RouteGuard]
			}
		]
	},
	{
		path: '**',
		redirectTo: 'not-found'
	}
];

@NgModule({
	imports: [RouterModule.forRoot(routes)],
	exports: [RouterModule]
})
export class AppRoutingModule { }
